"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTZ = void 0;
const date_fns_1 = require("date-fns");
const date_fns_tz_1 = require("date-fns-tz");
/**
 * あるタイムゾーンの日時をターゲットのタイムゾーンの日時に変換する
 * @param originDate 元のタイムゾーンの日時
 * @param originTz 元のタイムゾーン
 * @param targetTz ターゲットのタイムゾーン
 * 元のタイムゾーンとターゲットのタイムゾーンの時差を計算して元のDateに足す形で計算している
 * NOTE:
 * Dateはタイムゾーンに紐づかない(プレーンな日時のデータを持ったもの)であることに注意
 * ブラウザ上ではDateはUTCとみなされて良しなにブラウザの時刻に変換されるので、この関数を使うのは
 * フロントで new Date() した日時をブラウザのタイムゾーンから別のタイムゾーンに変換したい場合のみ
 */
const convertTZ = (originDate, originTz, targetTz) => {
    // originDateを渡すのは、サマータイムのある地域では日付によって時差が異なるため。
    const originOffsetMillSec = (0, date_fns_tz_1.getTimezoneOffset)(originTz, originDate);
    const targetTzOffsetMillSec = (0, date_fns_tz_1.getTimezoneOffset)(targetTz, originDate);
    const diffMillSec = targetTzOffsetMillSec - originOffsetMillSec;
    return (0, date_fns_1.addMilliseconds)(originDate, diffMillSec);
};
exports.convertTZ = convertTZ;
//# sourceMappingURL=convertTZ.js.map